import { find,findAll } from "../utils/dom";

const AccordionContent = () =>{
	const btAccordions = findAll('[js-bt-limit-content]');
	if(!btAccordions) return;


	function getID(btAccordion){
		const valueID = btAccordion.getAttribute('js-bt-limit-content');
		return valueID ? valueID : -1;
	}


	btAccordions.forEach((bt)=>{
		bt.addEventListener("click",(e)=>{
			e.preventDefault();
			const contentAccordion = find(`[js-limit-content="${getID(e.target)}"]`);
			if(!contentAccordion) return;

			const btText = e.target.querySelector("[js-bt-limit-text]");
			const btSvgPlus = e.target.querySelector("[js-bt-plus]");
			const btSvgMinus = e.target.querySelector("[js-bt-minus]");

			if(contentAccordion.classList.contains("is_open")){
				contentAccordion.style.maxHeight = `90px`;
				contentAccordion.classList.remove("is_open");
				btText.innerText = "Continuar lendo"
				btSvgPlus.style.display = "block"
				btSvgMinus.style.display = "none"
			}else{
				contentAccordion.style.maxHeight = `${contentAccordion.scrollHeight}px`;
				contentAccordion.classList.add("is_open");
				btText.innerText = "Ler menos"
				btSvgPlus.style.display = "none"
				btSvgMinus.style.display = "block"
			}

			
		})
	})

}

export default AccordionContent;